<template>
  <LayoutAppContent>
    <div class="p-5 text-center sm:pt-10">
      <h1 class="relative inline-block w-full p-12 text-center sm:w-1/2">
        <RocketLaunchIcon class="mx-auto h-12 w-12 text-gray-400" />
        <span class="mt-4 block text-xl font-medium text-gray-900"> Not Yet Implemented - Coming Soon!</span>
      </h1>
    </div>
  </LayoutAppContent>
</template>

<script lang="ts">
import { LayoutAppContent } from "@modernary/mui/components/layouts";
import { RocketLaunchIcon } from "@heroicons/vue/24/outline";
import { defineComponent } from "vue";
/**
 * Displays a not implemented screen to the user, meant to be used as a placeholder.
 */
export default defineComponent({
  name: "NotImplemented",
  components: { RocketLaunchIcon, LayoutAppContent },
  setup() {
    return {};
  },
});
</script>
